angular.module('env.i18n.serverLocalizationFilter', [])

    .filter('sTranslate', function (serverLocalization) {
        return function (input) {
            return serverLocalization.translate(input);
        };
    })

;